var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{attrs:{"link":"","to":_vm.menuItem.path}},[_c('v-list-item-icon',{staticClass:"ml-2"},[_c('icon',{attrs:{"small":"","color":"#1D3557","icon":_vm.menuItem.icon}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.menuItem.title))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }